import type {LeadStagesEdge_emailAutomationStatuses_emailSequence} from 'nutshell-graphql-types';

export function hasUnsentEmail(
    emailSequence: LeadStagesEdge_emailAutomationStatuses_emailSequence
): boolean {
    return Boolean(emailSequence.nextUnsentEmail);
}
